module.exports = __webpack_public_path__ + "img/silent_plus.38de4d15.jpg";